export const TRUSTPILOT_BUSINESS_UNIT_ID = "5a7973e0b43dd90001506fb5";
export const TRUSTPILOT_LOCALE = "en-US";
export const TRUSTPILOT_REVIEWS_URL = "https://www.trustpilot.com/review/net32.com";

const BOOTSTRAP_SCRIPT_SRC = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";

let bootstrapScript: HTMLScriptElement | null = null;
const failedScripts = new WeakSet<HTMLScriptElement>();

/**
 * Renders the TrustBox in `widget`, adding the bootstrap script to the page once and again after it fails.
 * Returns a cleanup function.
 */
export function loadTrustBox(widget: HTMLElement, onScriptError?: () => void): () => void {
  const render = () => window.Trustpilot?.loadFromElement(widget);
  if (window.Trustpilot) {
    render();
    return () => {};
  }

  const script = getBootstrapScript();
  script.addEventListener("load", render);
  if (onScriptError) {
    script.addEventListener("error", onScriptError);
  }

  return () => {
    script.removeEventListener("load", render);
    if (onScriptError) {
      script.removeEventListener("error", onScriptError);
    }
  };
}

function getBootstrapScript(): HTMLScriptElement {
  if (bootstrapScript?.isConnected && !failedScripts.has(bootstrapScript)) {
    return bootstrapScript;
  }

  bootstrapScript?.remove();
  const script = document.createElement("script");
  script.src = BOOTSTRAP_SCRIPT_SRC;
  script.async = true;
  script.addEventListener("error", () => failedScripts.add(script), { once: true });
  bootstrapScript = script;
  document.head.appendChild(script);
  return script;
}
